import BaseService from './base.service';
class CursosItensService extends BaseService {
    constructor() {
        super({ resource: 'EtapaDoCurso' });
    }
}
const cursosItensService = new CursosItensService();
export default cursosItensService;
